import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./app/page";
import Rootlayout from "./app/_root";
import LobbyRoot, {SlotLobby} from "./app/lobby/lobby";
import GameWindowRoot, {GameWindow} from "./app/window/game";
import HoldemPopWindow from './app/window/HoldemPopWindow';


const route = createBrowserRouter([
    {
        path: "/",
        element: <Rootlayout/>,
        children: [
            {
                path: "/",
                element: <Home />,
            },
            {
                path: "/gameLobby",
                element: <GameWindowRoot />,
                children: [
                    { path: ":vendor/", element: <GameWindow/> }
                ]
            },
            {
                path: "/holdem",
                element: <HoldemPopWindow />,
            }
        ]
    }
])




ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <RouterProvider router={route} />
);
